export const firebaseConfig = Object.freeze({
  apiKey: 'AIzaSyBFpc6MJsvPG76ruHst31bTw1kH8fAQx1c',
  authDomain: 'kingnetcare.firebaseapp.com',
  databaseURL: 'https://kingnetcare.firebaseio.com',
  projectId: 'kingnetcare',
  storageBucket: 'smartdaily-file',
  messagingSenderId: '865338099412',
  appId: '1:865338099412:web:1b0fc30cb1b695495edd41',
  measurementId: 'G-5QLP4J7VX6'
})
